<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "VrstaTemeBase"
};
</script>

<style scoped>

</style>
